import {Inject, Injectable, OnDestroy} from '@angular/core';
import {OverlayContainer} from '@angular/cdk/overlay';
import {DOCUMENT} from '@angular/common';
import { Platform } from '@angular/cdk/platform';

@Injectable({
    providedIn: 'root'
})

export class AppConfig extends OverlayContainer implements OnDestroy {
    // tslint:disable-next-line: variable-name
    constructor(@Inject(DOCUMENT) _document: any, _platform: Platform) {
        super(_document, _platform);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    _createContainer() {
        super._createContainer();
        this.appendToRoot();
    }
    getRootElement(): Element {
        return this._document.getElementById('am-container-custom');
    }
    appendToRoot() {
        if (!this._containerElement) {
            return;
        }
        const rootElem = this.getRootElement();
        const parent = rootElem || this._document.body;
        parent.appendChild(this._containerElement);
    }
}
